import { app } from './Api';

const getCompanies = async (nome = '') => {
    return app.get(`empresa?nome=${nome}`);
};

export { getCompanies };
